<div
    class="flex w-full items-center rounded-2xl px-4 py-8 text-left typo-sm"
    matRipple
    [matRippleDisabled]="disabled"
    [ngClass]="{
        'hover:bg-surface-100': !disabled,
        'justify-between': width() === 'content',
        'justify-center': width() === 'full',
    }"
>
    <div class="flex items-center">
        @if (icon(); as icon) {
            <interacta-icon
                class="mr-12 inline-block size-24 text-text-low-contrast"
                [icon]="icon"
            />
        }
        <ng-content />
    </div>

    @if (withArrow()) {
        <interacta-icon class="size-36" [icon]="'chevron-small-right'" />
    }
</div>
